"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APPLICATION_EMBED_CATEGORY_KEY = 'base';
exports.APPLICATION_EMBED_COMPONENT_KEY = 'applicationEmbed';